import Prices from '../../Prices';
import sanitizeHTML from '../../../utils/sanitiseHTML';
import feesNotes from '../../../utils/data/feesNotes';

const Price = ({ priceSection }) => {
  return (
    <div className="section__price">
      <Prices
        feesNotes={feesNotes}
        title={priceSection?.title}
        subTitle={priceSection?.subtitle}
      >
        <div className="section__price__footer subtitle_2" dangerouslySetInnerHTML={{ __html: sanitizeHTML(priceSection?.bottomParagraph) }} />
      </Prices>
    </div>
  );
};

export default Price;
